module.exports = __webpack_public_path__ + "media/images/uos-logo-6068f3e9f10f54db55318ade5b789e65.png";